import { Card, CardContent, CardHeader, CardTitle } from '@/components/shadcn-ui/card';
import { Button } from '@/components/shadcn-ui/button';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useProjectStore } from '@/stores/useProject.store';

const ProjectHome = () => {
  const navigate = useNavigate();
  const projects = useProjectStore(state => state.projects);
  const permitChatGroups = useProjectStore(state => state.permitChatGroups);

  const getFirstChatForProject = projectId =>
    permitChatGroups?.find(chat => chat.projectId === projectId);

  if (!projects || projects.length === 0) {
    return <div className="flex justify-center items-center text-muted-foreground">No projects found</div>;
  }

  return (
    <div className="flex flex-col gap-6 font-baloo-2-thin py-2">
      {/* Header */}
      <div className="flex flex-col gap-2 justify-center items-center">
        <h1 className="text-2xl font-semibold text-foreground">Your Project History</h1>
        <div>
          <p className="text-sm text-text-primary mt-1 text-center">We’ll update your projects automatically.</p>
          <p className="text-sm text-text-primary text-center">
            Return here anytime to review City responses and download your permit when approved.
          </p>
        </div>
      </div>

      {/* Project Cards */}
      {projects?.length > 0 && projects.map(project => (
        <Card key={project._id} className="dark rounded-[20px] bg-[#282828] shadow-lg shadow-black/30 border-[hsl(220,14%,20%)]">
          <CardHeader className="pb-3">
            <CardTitle className="text-base font-medium">{project.projectName}</CardTitle>
          </CardHeader>

          <CardContent className="flex items-center justify-between">
            {/* Status */}
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-yellow-500" />
              <span className="text-sm text-muted-foreground">{project.status || 'Submitted'}</span>
            </div>

            {/* Action */}
            <Button
              variant="ghost"
              size="sm"
              className="gap-1"
              disabled={!getFirstChatForProject(project._id)}
              onClick={() => {
                const chat = getFirstChatForProject(project._id);
                if (chat) navigate(`/citypermit/project/chat/${chat.chatId || chat._id}`, { state: { permitId: chat.permitId } });
              }}
            >
              View
              <ArrowRight className="h-4 w-4" />
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>

  );
};

export default ProjectHome;
